import React from 'react';
import { Link } from 'react-router-dom';

const EventReflections = () => {
  return (
    <section className="bg-gray-100">
      <div className="pt-12">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 pb-12">
          <section className="mb-12 pt-4">
            <p className="text-apple-gray-600 leading-relaxed mb-6">
              This talk was more than a lecture—it was a personal return to the place where my career began. I shared
              lessons from my journey, from building scrappy MVPs to leading multi-million dollar B2B SaaS platforms as a
              Senior Product Manager.
            </p>

            {/* Quote */}
            <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-apple-gray-600 mb-6">
              <blockquote className="text-lg text-apple-gray-700 italic mb-2">
                "Understanding systems like taxes and labor laws isn't just a legal formality—it's a competitive
                advantage."
              </blockquote>
              <cite className="text-apple-gray-600 font-medium">— Charly Cardeño</cite>
            </div>
          </section>

          {/* Back to Home */}
          <div className="text-center">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 bg-apple-gray-700 text-white font-medium rounded-lg hover:bg-apple-gray-800 transition duration-300"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 19l-7-7m0 0l7-7m-7 7h14" />
              </svg>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventReflections;